import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

export const PROPOSE_ADVISOR_SESSION_SCHEDULE = gql`
  mutation ProposeAdvisorSessionSchedule($input: ProposeAdvisorSessionScheduleInput!) {
    proposeAdvisorSessionSchedule(input: $input) {
      advisorSession {
        ...AdvisorSessionFragment
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`
